import React from "react";
import { PieChart, Pie} from "recharts";

const mockSummaryValue = {
  correctPercent: 75,
  wrongPercent: 25,
};

const PerformanceSummary = ({ correctPercent, wrongPercent } = mockSummaryValue) => {
 const data = [
    { name: "Correct answer", value: correctPercent, fill: "#22c55e" }, // DaisyUI green
    { name: "Wrong answer", value: wrongPercent, fill: "#ef4444" },     // DaisyUI red
  ];

//   const COLORS = ["#22c55e", "#ef4444"]; // DaisyUI green & red

  return (
    <div className="card bg-base-100 shadow-xl p-6 w-full">
      <h2 className="card-title mb-4">Overall Performance</h2>
      <div className="flex items-center">
        {/* Donut Chart */}
        <PieChart width={200} height={200}>
          <Pie
            data={data}
            cx="50%"
            cy="50%"
            innerRadius={50}
            outerRadius={80}
            paddingAngle={2}
            dataKey="value"
          />
            {/* {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[index]} />
            ))} */}
          {/* </Pie> */}
        </PieChart>

        {/* Labels */}
        <div className="ml-6 space-y-2">
          <div className="flex items-center text-green-600 font-medium">
            ✅ Correct answer {correctPercent}%
          </div>
          <div className="flex items-center text-red-600 font-medium">
            ❌ Wrong answer {wrongPercent}%
          </div>
        </div>
      </div>
    </div>
  );
};

export default PerformanceSummary;
